import { ArrowRight, CheckCircle } from "lucide-react";
import { Link } from "react-router-dom";

const packages = [
  {
    name: "Property Investment Consultation",
    price: "₦200,000 / £100",
    features: ["Investment guidance", "Legal process explanation", "Preliminary title review", "Risk identification"],
    note: "Credited toward full engagement"
  },
  {
    name: "Essential Due Diligence",
    price: "From ₦750,000",
    features: ["Title verification", "Ownership history", "Encumbrance checks", "Legal opinion report"]
  },
  {
    name: "Comprehensive Advisory",
    price: "From ₦1,800,000",
    features: ["Full due diligence", "Contract drafting", "Negotiation support", "Closing coordination"],
    featured: true
  },
  {
    name: "Premium Acquisition Advisory",
    price: "From ₦4,500,000",
    features: ["End-to-end advisory", "Developer due diligence", "Investment structuring", "Transaction oversight"]
  }
];

export const PackagesPreview = () => {
  return (
    <section 
      id="packages"
      className="py-16 md:py-24 lg:py-32 bg-[#FAFAF9] relative"
      data-testid="packages-preview"
    >
      {/* Decorative line - hidden on mobile */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-px h-12 md:h-20 bg-gradient-to-b from-[#D4AF37]/50 to-transparent hidden md:block" />
      
      <div className="max-w-7xl mx-auto px-5 md:px-8 lg:px-12">
        {/* Header */}
        <div className="text-center max-w-3xl mx-auto mb-12 md:mb-16 lg:mb-20">
          <span className="text-[#D4AF37] text-xs md:text-sm tracking-[0.2em] md:tracking-[0.3em] uppercase font-semibold">
            Advisory Packages
          </span>
          <h2 className="font-['Playfair_Display'] text-3xl md:text-4xl lg:text-5xl xl:text-6xl text-[#1A1A1A] mt-4 md:mt-6 mb-4 md:mb-6">
            Structured Legal Support
          </h2>
          <div className="w-16 md:w-20 h-px bg-[#D4AF37] mx-auto mb-4 md:mb-6" />
          <p className="text-[#1A1A1A]/50 text-sm md:text-base lg:text-lg px-2">
            Clear, transparent advisory packages designed for different investment needs.
          </p>
        </div>

        {/* Packages Preview - 2x2 Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6 mb-10 md:mb-16">
          {packages.map((pkg, index) => (
            <div
              key={index}
              className={`relative p-5 md:p-6 lg:p-8 border transition-all duration-500 ${
                pkg.featured 
                  ? "bg-[#0A0A0B] border-[#D4AF37] text-white" 
                  : "bg-white border-[#E5E5E5] hover:border-[#D4AF37]/50"
              }`}
              data-testid={`package-preview-${index}`}
            >
              {pkg.featured && (
                <div className="absolute -top-3 left-1/2 -translate-x-1/2 bg-[#D4AF37] text-[#0A0A0B] px-3 md:px-4 py-1 text-[9px] md:text-[10px] font-bold tracking-[0.15em] uppercase whitespace-nowrap">
                  Most Popular
                </div>
              )}
              
              <h3 className={`font-['Playfair_Display'] text-base md:text-lg lg:text-xl mb-2 ${pkg.featured ? "text-white" : "text-[#1A1A1A]"}`}>
                {pkg.name}
              </h3>
              <p className="font-['Playfair_Display'] text-lg md:text-xl lg:text-2xl text-[#D4AF37] mb-4 md:mb-6">
                {pkg.price}
              </p>
              
              <ul className="space-y-2 md:space-y-3">
                {pkg.features.map((feature, idx) => (
                  <li key={idx} className="flex items-start gap-2">
                    <CheckCircle className="w-3.5 h-3.5 md:w-4 md:h-4 text-[#D4AF37] flex-shrink-0 mt-0.5" />
                    <span className={`text-xs md:text-sm ${pkg.featured ? "text-white/70" : "text-[#1A1A1A]/60"}`}>
                      {feature}
                    </span>
                  </li>
                ))}
              </ul>
              
              {pkg.note && (
                <p className={`text-[10px] md:text-xs italic mt-4 ${pkg.featured ? "text-white/50" : "text-[#D4AF37]"}`}>
                  {pkg.note}
                </p>
              )}
            </div>
          ))}
        </div>

        {/* CTA */}
        <div className="text-center">
          <Link
            to="/packages"
            className="group inline-flex items-center gap-2 md:gap-3 bg-[#1A1A1A] text-white px-6 md:px-10 py-4 md:py-5 text-xs md:text-sm tracking-[0.15em] md:tracking-[0.2em] font-bold uppercase hover:bg-[#D4AF37] hover:text-[#0A0A0B] transition-all duration-300"
            data-testid="packages-view-all"
          >
            View All Packages
            <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
          </Link>
        </div>
      </div>
    </section>
  );
};
